export enum SalutationModel {
  MR = 'mr',
  MS = 'md',
}
